function Skill({ children }) {
    return (
        <div className="Exp-Skill">{children}</div>
    );
}

export default Skill;